import React, { forwardRef } from 'react';
import styled from '@emotion/styled';

import { Modal } from '../../../../components/Modals/Modal';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';
import LocumFilterModal from '../../../../components/Modals/ModalsActions/LocumFilterModal';

const LocumFilterButton = forwardRef<HTMLDivElement>(
  (props, ref) => {
    return (
      <ModalProvider>
        <ModalTriggerContainer ref={ref}>
          <None />
        </ModalTriggerContainer>
        <Modal>
          <LocumFilterModal />
        </Modal>
      </ModalProvider>
    );
  }
);

export default LocumFilterButton;

const None = styled.div`
  display: none;
`;
